import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { managerApi } from '../../config';

@Injectable({
  providedIn: 'root',
})
export class ManagerService {
  constructor(private apiService: ApiService) {}

  getAllChallengeTypes(param?: any): any {
    if (param) {
      return this.apiService.get(managerApi.getQuizChallengeTypes);
    }
    return this.apiService.get(managerApi.getAllChallengeTypes);
  }

  getChallengesByManager(params: any): any {
    return this.apiService.get(
      managerApi.getActivityChallengesByManagerId + params
    );
  }

  getChallengesParticipants(params: any): any {
    return this.apiService.get(
      managerApi.getChallengesParticipants,
      params
    );
  }

  getUsersUnderManager(managerId: any): any {
    return this.apiService.get(
      managerApi.getUsersUnderManager + '/' + managerId
    );
  }

  getPrescribedEnablementsManager(params: any): any {
    return this.apiService.get(
      managerApi.getPrescribedEnablementsManager,
      params
    );
  }

  postChallenge(challengeType: any, challengeData: any): any {
    return this.apiService.post(
      managerApi.postActivityChallenge + challengeType,
      challengeData
    );
  }

  updateChallenge(challengeType: any, challengeData: any): any {
    return this.apiService.put(
      managerApi.postActivityChallenge + challengeType,
      challengeData
    );
  }

  getArchitectureTypes(): any {
    return this.apiService.get(managerApi.getArchitectureTypes);
  }

  getEnablementCourses(): any {
    return this.apiService.get(managerApi.getEnablementCourses);
  }

  getTypesAndLearningMaps(): any {
    return this.apiService.get(managerApi.getTypesAndLearningMaps);
  }

  getTypesAndCourses(): any {
    return this.apiService.get(managerApi.getTypesAndCourses);
  }

  postEnablement(enablementData: any): any {
    return this.apiService.post(managerApi.postEnablement, enablementData);
  }

  getCompanyCreditsAvailable(compID: any): any {
    return this.apiService.get(
      managerApi.getCompanyCreditsAvailable + '?companyId=' + compID
    );
  }

  getCompanyTypePreferences(): any {
    return this.apiService.get(managerApi.getCompanyTypePreferences);
  }

  getSellerTypePreferences(): any {
    return this.apiService.get(managerApi.getSellerTypePreferences);
  }

  getCompanyPreferences(params: any): any {
    return this.apiService.get(managerApi.companyPreferences, params);
  }

  getSellerPreferences(params: any): any {
    return this.apiService.get(managerApi.sellerPreferences, params);
  }

  postCompanyPreferences(body: any): any {
    return this.apiService.post(managerApi.companyPreferences, body);
  }

  postcompanyListPreferences(body: any): any {
    return this.apiService.post(managerApi.companyListPreferences, body);
  }

  postSellerPreferences(body: any): any {
    return this.apiService.post(managerApi.postSellerPreferences, body);
  }

  getUserPreferences(params: any): any {
    return this.apiService.get(
      managerApi.postSellerPreferences + '/' + params.userId + '/' + params.preferenceId
    );
  }

  getCompanyPoints(companyId: any): any {
    return this.apiService.get(managerApi.getCompanyPoints + '/' + companyId);
  }

  getCompanyUsersPoints(companyId: any, queryParams: any): any {
    const url = managerApi.getCompanyUsersPoints.replace(
      '{companyId}',
      companyId
    );
    return this.apiService.get(url, queryParams);
  }

  updateSingleUserPoints(body: any): any {
    return this.apiService.post(managerApi.updateSingleUserPoints, body);
  }

  getFiscalPeriod(params: any): any {
    return this.apiService.get(managerApi.fiscalPeriod, params);
  }

  deleteChallenge(challengeId: any): any {
    return this.apiService.delete(
      managerApi.deleteChallenge + '/' + challengeId
    );
  }

  deleteActiveChallenge(challengeId: any): any {
    return this.apiService.delete(
      managerApi.deleteActiveChallenge + '/' + challengeId
    );
  }

  updateMultipleUserPoints(body: any): any {
    return this.apiService.post(managerApi.updateMultipleUserPoints, body);
  }

  adminClaimForUser(params: any): any {
    return this.apiService.post(
      managerApi.adminClaimForUser + '?userId=' + params.userId + '&dealId=' + params.dealId
    );
  }

  adminClaimAll(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.adminClaimall + '?userId=' + params.userId
    );
  }

  datacenterClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.datacenterClaimall + '?userId=' + params.userId
    );
  }

  nexusClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.nexusClaimall + '?userId=' + params.userId
    );
  }

  flexToClaimed(companyId: any, params: any): any {
    const url = managerApi.flexToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(url, params);
  }

  flexClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.flexClaimall + '?userId=' + params.userId
    );
  }

  webexToClaimed(companyId: any, params: any): any {
    const url = managerApi.webexToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(url, params);
  }

  webexClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.webexClaimall + '?userId=' + params.userId
    );
  }

  securityRewardToClaimed(companyId: any, params: any): any {
    const url = managerApi.securityRewardToClaimed.replace(
      '{companyId}',
      companyId
    );
    return this.apiService.get(url, params);
  }

  securityRewardClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.securityRewardClaimall + '?userId=' + params.userId
    );
  }

  wirelessAcceToClaimed(companyId: any, params: any): any {
    const url = managerApi.wirelessAcceToClaimedToClaimed.replace(
      '{companyId}',
      companyId
    );
    return this.apiService.get(url, params);
  }

  wirelessAcceRewardClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.wirelessAccClaimall + '?userId=' + params.userId
    );
  }

  mdsRewardToClaimed(companyId: any, params: any): any {
    const url = managerApi.mdsRewardToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(url, params);
  }

  mdsRewardClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.mdsRewardClaimall + '?userId=' + params.userId
    );
  }

  sdwanAccelerationToClaimed(companyId: any, params: any): any {
    const url = managerApi.sdwanAccelerationToClaimed.replace(
      '{companyId}',
      companyId
    );
    return this.apiService.get(url, params);
  }

  sdwanAccelerationClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.sdwanAccelerationClaimall + '?userId=' + params.userId
    );
  }

  collaborationSprintClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.collaborationSprintClaimAll + '?userId=' + params.userId
    );
  }

  getpoSearchResult(params: any): any {
    return this.apiService.get(
      managerApi.poSearchResult + '?searchText=' + params.searchText + '&companyId=' + params.companyId
    );
  }

  pointAccountSellerClaimedBySeller(params: any): any {
    return this.apiService.get(
      managerApi.pointAccountSellerClaimedBySeller,
      params
    );
  }

  pointAccountClaimedByAdmin(params: any): any {
    return this.apiService.get(
      managerApi.pointAccountClaimedByAdmin,
      params
    );
  }

  enterpriseNetworkToClaimed(companyId: any, params: any): any {
    const url = managerApi.enterpriseNetworkToClaimed.replace(
      '{companyId}',
      companyId
    );
    return this.apiService.get(url, params);
  }

  enterpriseNetworkClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.enterproseNetworkClaimall + '?userId=' + params.userId
    );
  }

  designedPortfolioToClaimed(companyId: any, params: any): any {
    const url = managerApi.designedPortfolioToClaimed.replace(
      '{companyId}',
      companyId
    );
    return this.apiService.get(url, params);
  }

  designedPortfolioClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.designedPortfolioClaimall + '?userId=' + params.userId
    );
  }

  cloudCallingToClaimed(companyId: any, params: any): any {
    const url = managerApi.cloudCallingToClaimed.replace(
      '{companyId}',
      companyId
    );
    return this.apiService.get(url, params);
  }

  cloudCallingClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.cloudCallingClaimall + '?userId=' + params.userId
    );
  }

  getRedemptionTaxStatement(params: any): any {
    return this.apiService.get(
      managerApi.pointAccountRedemptionTaxStatement,
      params
    );
  }

  merakiToClaimed(companyId: any, params: any): any {
    const url = managerApi.merakiToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(url, params);
  }

  dnaToClaimed(companyId: any, params: any): any {
    const url = managerApi.dnaToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(url, params);
  }

  dnaClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.dnaClaimall + '?userId=' + params.userId
    );
  }

  wanToClaimed(companyId: any, params: any): any {
    const url = managerApi.wanToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(url, params);
  }

  wanClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.wanClaimall + '?userId=' + params.userId
    );
  }

  saseToClaimed(companyId: any, params: any): any {
    const url = managerApi.saseToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(url, params);
  }

  saseClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.saseClaimall + '?userId=' + params.userId
    );
  }

  ibnToClaimed(companyId: any, params: any): any {
    const url = managerApi.ibnToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(url, params);
  }

  ibnClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.ibnClaimall + '?userId=' + params.userId
    );
  }

  getBudgetCapBars(params: any): any {
    return this.apiService.post(
      managerApi.getBudgetCapBars + '?companyId=' + params.companyId + '&scNumber=' + params.scNumber + '&userId=' + params.userId
    );
  }

  eaToClaimed(companyId: any, params: any): any {
    const url = managerApi.eaToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(url, params);
  }

  eaClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.eaClaimall + '?userId=' + params.userId
    );
  }

  officeToClaimed(companyId: any, params: any): any {
    const url = managerApi.officeToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(url, params);
  }

  officeClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.officeClaimall + '?userId=' + params.userId
    );
  }

  iotsalesToClaimed(companyId: any, params: any): any {
    const url = managerApi.iotsalesToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(url, params);
  }

  iotsalesClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.iotsalesClaimall + '?userId=' + params.userId
    );
  }

  collabToClaimed(companyId: any, params: any): any {
    const url = managerApi.collabToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(url, params);
  }

  collabClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.collabClaimall + '?userId=' + params.userId
    );
  }

  intersightToClaimed(companyId: any, params: any): any {
    const url = managerApi.intersightToClaimed.replace(
      '{companyId}',
      companyId
    );
    return this.apiService.get(url, params);
  }

  intersightClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.intersightClaimall + '?userId=' + params.userId
    );
  }

  ciscoCloudCallingToClaimed(companyId: any, params: any): any {
    const url = managerApi.ciscoCloudCallingToClaimed.replace(
      '{companyId}',
      companyId
    );
    return this.apiService.get(url, params);
  }

  ciscoCloudCallingClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.ciscoCloudCallingClaimall + '?userId=' + params.userId
    );
  }

  ciscoCloudContactToClaimed(companyId: any, params: any): any {
    const url = managerApi.ciscoCloudContactToClaimed.replace(
      '{companyId}',
      companyId
    );
    return this.apiService.get(url, params);
  }

  ciscoCloudContactClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.ciscoCloudContactClaimall + '?userId=' + params.userId
    );
  }

  ealToClaimed(companyId: any, params: any): any {
    const url = managerApi.ealToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(url, params);
  }

  ealClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.ealClaimall + '?userId=' + params.userId
    );
  }

  massScaleInfrastructureChallengeDealsToClaimed(companyId: any, params: any): any {
    const url =
      managerApi.massScaleInfrastructureChallengeDealsToClaimed.replace(
        '{companyId}',
        companyId
      );
    return this.apiService.get(url, params);
  }

  fastStartChallengeDealsToClaimed(companyId: any, params: any): any {
    const url = managerApi.fastStartChallengeDealsToClaimed.replace(
      '{companyId}',
      companyId
    );
    return this.apiService.get(url, params);
  }

  massScaleInfrastructureChallengeDealsClaimAll(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.massScaleInfrastructureChallengeDealsClaimAll + '?userId=' + params.userId
    );
  }

  fastStartChallengeDealsClaimAll(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.fastStartChallengeDealsClaimAll + '?userId=' + params.userId
    );
  }

  doubleUpSecurityChallengeDealsToClaimed(companyId: any, params: any): any {
    const url = managerApi.doubleUpSecurityChallengeDealsToClaimed.replace(
      '{companyId}',
      companyId
    );
    return this.apiService.get(url, params);
  }

  claimAllDoubleUpSecurity(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.claimAllDoubleUpSecurity + '?userId=' + params.userId
    );
  }

  salesAccelerationChallengeDealsToClaimed(companyId: any, params: any): any {
    const url = managerApi.salesAccelerationChallengeDealsToClaimed.replace(
      '{companyId}',
      companyId
    );
    return this.apiService.get(url, params);
  }

  hybridWorkSalesAccelerationChallengeDealsToClaimed(companyId: any, params: any): any {
    const url =
      managerApi.hybridWorkSalesAccelerationChallengeDealsToClaimed.replace(
        '{companyId}',
        companyId
      );
    return this.apiService.get(url, params);
  }

  boostForSmallBusinessSalesChallengeDealsToClaimed(companyId: any, params: any): any {
    const url =
      managerApi.boostForSmallBusinessSalesChallengeDealsToClaimed.replace(
        '{companyId}',
        companyId
      );
    return this.apiService.get(url, params);
  }

  claimAllBoostForSmallBusiness(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.claimAllDoubleUpSecurity + '?userId=' + params.userId
    );
  }

  bigMerakiSalesChallengeDealsToClaimed(companyId: any, params: any): any {
    const url = managerApi.bigMerakiSalesChallengeDeals.replace(
      '{companyId}',
      companyId
    );
    return this.apiService.get(url, params);
  }

  sellTheSuiteSalesChallengeDealsToClaimed(companyId: any, params: any): any {
    const url = managerApi.sellTheSuiteSalesChallengeDeals.replace(
      '{companyId}',
      companyId
    );
    return this.apiService.get(url, params);
  }

  claimAllSellTheSuite(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.claimAllSellTheSuite + '?userId=' + params.userId
    );
  }

  commercialSellerChallengeDealsToClaimed(companyId: any, params: any): any {
    const url = managerApi.commercialSellerChallengeDeals.replace(
      '{companyId}',
      companyId
    );
    return this.apiService.get(url, params);
  }

  claimAllCommercialSeller(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.claimAllCommercialSeller + '?userId=' + params.userId
    );
  }

  mspSalesAccelerationChallengeDeals(companyId: any, params: any): any {
    const url = managerApi.mspSalesAccelerationChallengeDeals.replace(
      '{companyId}',
      companyId
    );
    return this.apiService.get(url, params);
  }

  aacpcChalengToClaimed(companyId: any, params: any): any {
    const url = managerApi.aacpcSalesChallenge.replace(
      '{companyId}',
      companyId
    );
    return this.apiService.get(url, params);
  }

  aacpcClaimall(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.claimAllAacpc + '?userId=' + params.userId
    );
  }

  webMediaSalesChallengeDealsToClaimed(companyId: any, params: any): any {
    const url = managerApi.webMediaSalesChallengeDeals.replace(
      '{companyId}',
      companyId
    );
    return this.apiService.get(url, params);
  }

  claimAllWebMedia(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.claimAllWebMedia + '?userId=' + params.userId
    );
  }

  newCloudCallingChallengeDealsToClaimed(companyId: any, params: any): any {
    const url = managerApi.newCloudCallingChallengeDeals.replace(
      '{companyId}',
      companyId
    );
    return this.apiService.get(url, params);
  }

  claimAllNewCloudCalling(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.claimAllNewCloudCalling + '?userId=' + params.userId
    );
  }

  getViewChallengeData(params: any): any {
    return this.apiService.get(managerApi.viewChallenge + params);
  }

  getCountryGroupList(): any {
    return this.apiService.get(managerApi.countryGroupList);
  }

  submitForApproval(params: any): any {
    return this.apiService.post(managerApi.submitForApproval + params);
  }

  getsalesChallengeDeals(params: any): any {
    return this.apiService.get(
      managerApi.salesChallengeeligibleDeals + params
    );
  }

  claimAllChallengeDeals(params: any): any {
    return this.apiService.post(
      managerApi.claimAllChallengeDeals + params
    );
  }

  getApprovalData(params: any): any {
    return this.apiService.get(managerApi.approvalTracker + params);
  }

  claimAllDeals(params: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.claimAll + params
    );
  }

  getpointActivityData(params: any): any {
    return this.apiService.get(managerApi.pointActivityLeader + params);
  }

  getDistributedPointActivityData(params: any): any {
    return this.apiService.get(
      managerApi.distributedPointActivity + params
    );
  }

  getLeaderTicketActivityData(params: any): any {
    return this.apiService.get(managerApi.ticketActivityLeader + params);
  }

  getSalesActivityData(params: any): any {
    return this.apiService.get(managerApi.salesActivityData + params);
  }

  getSalesChallengeData(params: any): any {
    return this.apiService.get(
      managerApi.salesChallengePerformence + params
    );
  }

  getClaimedUnclaimedData(params: any): any {
    return this.apiService.get(managerApi.claimStatusSummary + params);
  }

  getStatisticsData(params: any): any {
    return this.apiService.get(managerApi.statisticsData + params);
  }

  createChallenge(params: any): any {
    return this.apiService.get(managerApi.statisticsData + params);
  }

  createBookingChallenge(bookingChallengeData: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.createBookingChallenge,
      bookingChallengeData
    );
  }

  createTrainingChallenge(trainingChallengeData: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.createTrainingChallenge,
      trainingChallengeData
    );
  }

  createArchitectureChallenge(architectureChallengeData: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.createArchitectureChallenge,
      architectureChallengeData
    );
  }

  getBookingChallengeById(challengeId: any): any {
    return this.apiService.getCompleteResponse(
      managerApi.getBookingChallengeById + challengeId
    );
  }

  getTrainingChallengeById(challengeId: any): any {
    return this.apiService.getCompleteResponse(
      managerApi.getTrainingChallengeById + challengeId
    );
  }

  getArchitectureChallengeById(challengeId: any): any {
    return this.apiService.getCompleteResponse(
      managerApi.getArchitectureChallengeById + challengeId
    );
  }

  updateBookingChallenge(bookingChallengeData: any): any {
    return this.apiService.put(
      managerApi.createBookingChallenge,
      bookingChallengeData
    );
  }

  updateTrainingChallenge(trainingChallengeData: any): any {
    return this.apiService.put(
      managerApi.createTrainingChallenge,
      trainingChallengeData
    );
  }

  updateArchitectureChallenge(architectureChallengeData: any): any {
    return this.apiService.put(
      managerApi.createArchitectureChallenge,
      architectureChallengeData
    );
  }

  deleteActivityChallenge(challengeId: any): any {
    return this.apiService.delete(
      managerApi.deleteActivityChallenge + '/' + challengeId
    );
  }

  updateActivityChallengeStatus(params: any): any {
    return this.apiService.post(managerApi.updateStatus + '/' + params);
  }

  getFiscalOptions(): any {
    return this.apiService.get(managerApi.fiscalOptions);
  }

  getParticipantsChallengeById(challengeId: any): any {
    return this.apiService.getCompleteResponse(
      managerApi.getParticipantsChallenge + challengeId
    );
  }

  createParticipantsChallenge(data: any): any {
    return this.apiService.postCompleteResponse(
      managerApi.createParticipantsChallenge,
      data
    );
  }

  updateParticipantsData(params: any): any {
    return this.apiService.put(
      managerApi.createParticipantsChallenge,
      params
    );
  }

  getCountryListByRegion(regionList: any): any {
    return this.apiService.get(
      managerApi.getCountryListByRegion + '?regions=' + regionList
    );
  }

  createNewLeaderboardChallenge(payload: any): any {
    if (payload.id) {
      return this.apiService.put(
        managerApi.createLeaderboardChallenge,
        payload
      );
    }
    return this.apiService.post(
      managerApi.createLeaderboardChallenge,
      payload
    );
  }

  getLeaderBoardChallengesListCiscoAdmin(params: any): any {
    return this.apiService.get(
      managerApi.getLeaderBoardChallengesListCiscoAdmin + params
    );
  }

  getLeaderBoardChallengesListLeader(params: any): any {
    return this.apiService.get(
      managerApi.getLeaderBoardChallengesListLeader,
      params
    );
  }

  getLeaderBoardChallengesListSeller(params: any): any {
    return this.apiService.get(
      managerApi.getLeaderBoardChallengesListSeller,
      params
    );
  }

  getLeaderboardChallengeById(id: any): any {
    return this.apiService.get(
      managerApi.getLeaderBoardChallengeById + id
    );
  }

  getActivityData(startDate: any, endDate: any, regions: any, participantType: any): any {
    return this.apiService.get(
      managerApi.activityChallenge + '?startDate=' + startDate + '&endDate=' + endDate + '&regions=' + regions + '&participantType=' + participantType
    );
  }

  deleteLeaderboardChallengeById(challengeId: any): any {
    return this.apiService.delete(
      managerApi.deleteLeaderboardChallengeById + '/' + challengeId
    );
  }

  updateLeaderboardChallengeStatus(params: any): any {
    return this.apiService.post(
      managerApi.updateLeaderboardChallengeStatus + '?id=' + params.id + '&status=' + params.status
    );
  }

  createProductBookingChallenge(payload: any): any {
    if (payload.id) {
      return this.apiService.put(
        managerApi.createProductsBooking,
        payload
      );
    }
    return this.apiService.post(
      managerApi.createProductsBooking,
      payload
    );
  }

  getProductBookingById(id: any): any {
    return this.apiService.get(managerApi.getProductBookingById + id);
  }

  getProductBookingProgress(id: any): any {
    return this.apiService.get(managerApi.getProductBookingProgress + id);
  }

  getCustomChallenges(params: any): any {
    return this.apiService.get(managerApi.getCustomChallenges, params);
  }

  getActivityChallengeById(challengeName: any, id: any): any {
    return this.apiService.get(
      managerApi.postActivityChallenge + challengeName + '/' + id
    );
  }

  getAdminActivityChallengeById(challengeName: any, id: any): any {
    return this.apiService.get(
      managerApi.getAdminActivityChallenge + challengeName + '/' + id
    );
  }

  cloneActivityChallengeById(challengeName: any, id: any): any {
    return this.apiService.get(
      managerApi.cloneActivityChallenge + challengeName + '/' + id
    );
  }

  cloneLeaderChallengeById(id: any): any {
    return this.apiService.get(
      managerApi.cloneLeaderboardChallengeById + id
    );
  }

  getActivityFiscalOptions(): any {
    return this.apiService.get(managerApi.activityFiscalOptions);
  }

  getAcPossibleValues(): any {
    return this.apiService.get(managerApi.acPossibleValues);
  }

  checkOverrideFromAutoToManual(pathParams: any): any {
    return this.apiService.get(
      managerApi.checkOverrideFromAutoToManual + pathParams
    );
  }

  acSubmitProofs(id: any, fileData: any, params: any): any {
    return this.apiService.postForFileProgress(
      managerApi.submitProof + '/' + id + params,
      fileData
    );
  }

  getProofOfDocumentsList(id: any): any {
    return this.apiService.get(
      managerApi.proofOfDocuments + '?userChallengeId=' + id
    );
  }

  getDocTypeList(): any {
    return this.apiService.get(managerApi.docTypesList);
  }

  getCommentsById(chatData: any): any {
    if (chatData.fileData.name === 'chatModal') {
      const url = managerApi.getCommentsByFileId +
        '?userChallengeId=' + chatData.fileData.approverData.userChallengeId +
        '&fileId=' + chatData.fileData.approverData.fileId;
      return this.apiService.get(url);
    }
    return this.apiService.get(
      managerApi.getCommentsByFileId + '?userChallengeId=' + chatData.userChallengeId + '&fileId=' + chatData.fileData.id
    );
  }

  addCommentsById(chatData: any): any {
    return this.apiService.post(managerApi.addCommentsByFileId + chatData);
  }

  getActiveLeaderboardChallenges(startDate: any, endDate: any, regions: any, participantType: any): any {
    const params = '?startDate=' + startDate + '&endDate=' + endDate +
      '&regions=' + regions + '&participantType=' + participantType;
    return this.apiService.get(managerApi.activeLeaderboardChallenge + params);
  }

  getLeaderboardChgProgress(id: any): any {
    return this.apiService.get(
      managerApi.getLeaderboardChallengeProgress + id
    );
  }

  getEnablementCourseTypes(): any {
    return this.apiService.get(managerApi.enablementCourseTypes);
  }

  addRebateCoordinators(req: any): any {
    return this.apiService.post(managerApi.rebatecoordinators, req);
  }

  getRebateCoordinators(req: any): any {
    return this.apiService.get(managerApi.getRebateCoordinators + req);
  }

  generateFileTansCDocuments(req: any): any {
    return this.apiService.get(
      managerApi.generateTandConditionsFile + req
    );
  }

  generateEligProductsDocumentationAsDownloadable(req: any): any {
    return this.apiService.get(
      managerApi.generateEligProductsDocumentationAsDownloadable + req
    );
  }

  getEligibleProductsDownloadLink(fiscalYear: any, quarter: string): any {
    return this.apiService.getText(
      managerApi.eligibleProductsDownload + '?fiscalYear=' + fiscalYear + '&quarter=' + quarter
    );
  }

  getQuarterLevelBudgetcapData(req: any) {
    return this.apiService.get(`${managerApi.getQuaterLevelBudget}${req}`);
  }
  saveQuarterLevelBudget(payload: any){
    return this.apiService.post(managerApi.saveQuarterLevelBudget, payload);
  }
    updateBudgetcapData(id: any, payload: any){
    return this.apiService.put(
      `${managerApi.updateBudgetcapData}/${id}`, payload
    );
  }

}
